module.exports = __webpack_public_path__ + "img/AM.6e96a682.svg";